<div class="shareContainer">

  <div class="shareModalBox">
      <div class="imgShare">
          <img class="logoShare" [src]="srcIconCoin" alt="Share">
      </div>

      <div class="backArrowSection">
        <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
      </div>
      <span class="title-share">{{'freeCarrot' | translate}}</span>

      <div class="txt-description">
        {{'referAFriendToVeggly' | translate}}
      </div>
      <br>

      <ion-button class="shareButton" shape="round" (click)="profileSharePerCarrots()">
        {{'share' | translate}}
      </ion-button >
  </div>
</div>